import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { RegistrationData } from '../../models';
import { HttpClient } from '@angular/common/http';
import { RegistrationService } from '../../services/registration.service';
import { firstValueFrom } from 'rxjs';
import { isErrorResponse } from '../../services/base.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-registration',
    imports: [FormsModule, RouterModule],
    templateUrl: './registration.component.html',
    styleUrl: './registration.component.css'
})
export class RegistrationComponent {

  registrationData: Partial<RegistrationData> = {
    whatsapp: '',
    name: '',
    website: '',
    logo: '',
    acceptPolicy: false,
    registeredAt: '',
    validity: 365,     
    expired: false 
  };

  company: any = null;
  loading = false;
  message = '';
  messageType: 'success' | 'error' = 'success';

  constructor(private http: HttpClient,
    private registrationService: RegistrationService,
    private router: Router) { }

  ngOnInit() {
  }

  // Save registration data
  async onSubmit(event: Event) {
    event.preventDefault();

    if (!this.validateForm()) {
      return;
    }

    this.loading = true;
    this.message = '';

    try {
      this.registrationData.registeredAt = new Date().toISOString();

      // ONLY EXPIRY SET (365 DAYS)
      this.registrationData.validity = 365;
      this.registrationData.expired = false;

      const response = await firstValueFrom(this.registrationService.create(this.registrationData));
      if (isErrorResponse(response)) {
        throw new Error(response.error || 'Registration failed');
      } else {
        this.messageType = 'success';
        this.message = 'Registration successful! Redirecting to payment...';
        // this.goToWhatsappOtp(this.registrationData.whatsapp!);
        this.goToPayment(response.id);
      }
    } catch (error: any) {
      this.messageType = 'error';
      this.message = error.error?.message || error.message || 'Registration failed. Please try again.';
      console.error('Registration error:', error);
    } finally {
      this.loading = false;
    }
  }

  goToWhatsappOtp(phone: string) {
    this.router.navigate(['/otp'], { state: { whatsapp: phone } });
  }

  goToPayment(id: string) {
    this.router.navigate(['/pay'], { state: { registrationId: id } });
  }

  private validateForm(): boolean {
    if (this.registrationData.whatsapp && !this.registrationData.whatsapp.match(/^\+\d{10,15}$/)) {
      this.messageType = 'error';
      this.message = 'Please enter a valid WhatsApp number with country code';
      return false;
    }

    if (this.registrationData.name && !this.registrationData.name.trim()) {
      this.messageType = 'error';
      this.message = 'Company name is required';
      return false;
    }

    if (this.registrationData.website && !this.registrationData.website.match(/^https?:\/\/.+/)) {
      this.messageType = 'error';
      this.message = 'Please enter a valid website URL';
      return false;
    }

    if (!this.registrationData.acceptPolicy) {
      this.messageType = 'error';
      this.message = 'You must accept the terms';
      return false;
    }

    return true;
  }

  private resetForm() {
    this.registrationData = {
      whatsapp: '',
      name: '',
      website: '',
      logo: '',
      acceptPolicy: false,
      registeredAt: '',
      validity: 365,   
      expired: false
    };
  }

  getCompanyId(company: any): string {
    return company.id;
  }

  onLogoPreviewError(event: any) {
    event.target.style.display = 'none';
  }

 

}
